import React, {Component} from 'react';
import { InvalidPlayerInterface } from 'components/organisms/late-swap/services/invalid-player';

interface Props {
    invalidPlayers: Array<InvalidPlayerInterface>;
}

class InvalidPlayers extends Component<Props> {
    private readonly getRequiredPropsMetadata = (): Array<{name: string, prop: string}> => {
        return [
            {name: 'Pos', prop: 'positionName'},
            {name: 'Name', prop: 'name'},
            {name: 'ID', prop: 'externalId'},
            {name: 'Salary', prop: 'salary'},
            {name: 'Team', prop: 'team'},
        ];
    }

    private readonly filterInvalidPlayers = (invalidPlayers: Array<InvalidPlayerInterface>): Array<InvalidPlayerInterface> => {
        const requiredPropsMetadata = this.getRequiredPropsMetadata();

        return invalidPlayers.filter((invalidPlayer) => {
            return requiredPropsMetadata.some(({prop}) => !invalidPlayer.invalidProps.includes(prop));
        });
    }

    render() {
        const {invalidPlayers} = this.props;
        const filteredInvalidPlayers = this.filterInvalidPlayers(invalidPlayers);

        return (
            <>
                <p>Attention, please! Some players in the uploaded CSV contain missing or invalid required data. Players that could not be matched or added to the slate were skipped, along with any related lineups. Please review and update the CSV file.</p>
                {filteredInvalidPlayers.length > 0 && (
                <table className="table table-players">
                    <thead>
                        <tr>
                            {this.getRequiredPropsMetadata().map(({name}, index) => {
                                return (<th key={index}>{name}</th>);
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {filteredInvalidPlayers.map((invalidPlayer, i) => {
                            return (
                                <tr key={i}>
                                    {this.getRequiredPropsMetadata().map(({prop}, j) => {
                                        const className = invalidPlayer.invalidProps.includes(prop) ? 'invalid-cell' : '';

                                        return (
                                            <td className={className} key={`${i}-${j}`}>{invalidPlayer.player[prop]}</td>
                                        );
                                    })}
                                </tr>
                            );
                        })}
                        </tbody>
                    </table>
                )}
            </>
        );
    }
}

export {InvalidPlayers};
